module.exports = __webpack_public_path__ + "static/media/Ali_Avatar_Soccer.43599252.svg";